import { render, staticRenderFns } from "./HistorialObjeto.vue?vue&type=template&id=a681eede"
import script from "./HistorialObjeto.vue?vue&type=script&lang=js"
export * from "./HistorialObjeto.vue?vue&type=script&lang=js"
import style0 from "./HistorialObjeto.vue?vue&type=style&index=0&id=a681eede&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports